// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfse from './selecao_todos_nfse';
import { Input } from '../../../../../../common/input';

type CamposPessoaProps = {
  nome : string,
  titulo : string,
}

export default function CamposPessoa({ nome, titulo } : CamposPessoaProps) {
  const tipoPrestador     = nome === 'prestador',
        tipoTomador       = nome === 'tomador',
        tipoIntermediario = nome === 'intermediario';

  return (
      <FormSection name={ nome }>
        <fieldset>
          <SelecaoTodosNfse nomes={ [ nome ] } titulo={ titulo }/>

          <div className="grupo-checkbox">
            <Input name={ `${nome}CpfCnpj` } label="CNPJ / CPF" checkbox/>
            { (tipoPrestador || tipoTomador) &&
              <>
                <Input name={ `${nome}RazaoSocial` } label="Razão Social" checkbox/>
                <Input name={ `${nome}Municipio` } label="Município" checkbox/>
                <Input name={ `${nome}Uf` } label="UF" checkbox/>
              </>
            }
            <Input name={ `${nome}Im` } label="Inscrição Municipal (IM)" checkbox/>
            { tipoPrestador && <Input name="simplesOpcao" label="Opção Simples" checkbox/> }
            { (tipoTomador || tipoIntermediario) && <Input name={ `${nome}Email` } label="E-mail" checkbox/> }
          </div>
        </fieldset>
      </FormSection>
  );
}